import {
  becomeCollegeAmbassador,
  getLandingNepalCollegeDropdown,
  setCollegeEditData,
} from '@/actions/college';
import { blockInvalidChar } from '@/helpers/formDataHelper';
import { Button, Col, Row, Select, notification } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const AmbassadorForm = () => {
  const dispatch = useDispatch();
  const { status, collegeDropdown, error } = useSelector((state: any) => ({
    status: state?.college?.ambassadorFormStatus,
    collegeDropdown: state?.college?.collegeDropdown,
    error: state?.college?.error?.addAmbassador,
  }));

  const [data, setData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    message: '',
    college: '',
  });

  useEffect(() => {
    if (status === 'success') {
      notification.success({
        message: 'Thank you! Your form has been submitted.',
      });

      setData({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        message: '',
        college: '',
      });
    } else if (status === 'failure') {
      notification.error({
        message:
          Object.keys(error)?.length > 0
            ? Object.values(error)[0][0]
            : 'Failed to submit your form',
      });
    }
    status &&
      setTimeout(() => {
        dispatch(setCollegeEditData({ key: 'ambassadorFormStatus', value: '' }));
      }, 3000);
  }, [status]);

  useEffect(() => {
    if (data?.college?.length >= 1) {
      const getData = setTimeout(() => {
        dispatch(
          getLandingNepalCollegeDropdown({
            data: { name: data?.college },
          })
        );
      }, 1000);

      return () => clearTimeout(getData);
    }
  }, [data?.college]);

  const onSearchCollege = (value: string) => {
    setData({ ...data, college: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!data?.college) {
      notification.error({ message: 'Please select School/College' });
    } else if (data?.phone_number?.length < 10) {
      notification.error({
        message: 'Phone number must be atleast 10 digits',
      });
    } else {
      const newData = {
        first_name: data?.first_name,
        last_name: data?.last_name,
        email: data?.email,
        college: data?.college,
        message: data?.message,
        phone_number: data?.phone_number,
      };
      dispatch(becomeCollegeAmbassador(newData));
    }
  };

   return (
     <div className="ambassador-form" id="ambassador-form">
       <Row className="mt-4 justify-content-center my-5 px-3">
         <Col md={12}>
           <h1>Join Learnsic as Ambassador</h1>
           <form id="ambassadorForm" onSubmit={handleSubmit}>
             <div className="form-row">
               <div className=" col-lg-6 col-md-12">
                 <div className="form-group">
                   <input
                     value={data.first_name}
                     onChange={(e) =>
                       setData({ ...data, first_name: e.target.value })
                     }
                     type="text"
                     className="form-control w-100"
                     placeholder="First Name"
                     required
                   />
                 </div>
               </div>
               <div className="col-lg-6 col-md-12">
                 <div className="form-group">
                   <input
                     value={data.last_name}
                     onChange={(e) =>
                       setData({ ...data, last_name: e.target.value })
                     }
                     type="text"
                     className="form-control w-100"
                     placeholder="Last Name"
                     required
                   />
                 </div>
               </div>
             </div>
             <div className="form-row">
               <div className="col-lg-6 col-md-6">
                 <div className="form-group">
                   <input
                     type="email"
                     value={data.email}
                     onChange={(e) => setData({ ...data, email: e.target.value })}
                     className="form-control w-100"
                     placeholder="Email"
                     required
                   />
                 </div>
               </div>
               <div className="col-lg-6 col-md-6">
                 <div className="form-group">
                   <input
                     type="number"
                     value={data.phone_number}
                     onChange={(e) =>
                       setData({ ...data, phone_number: e.target.value })
                     }
                     className="form-control w-100"
                     placeholder="Phone Number"
                     required
                     onKeyDown={blockInvalidChar}
                   />
                 </div>
               </div>
             </div>
             <div className="form-row">
               <div className="col-lg-12 col-md-12">
                 <div className="form-group">
                   <Select
                     showSearch
                     placeholder="Search for your School/College"
                     getPopupContainer={(node) => node.parentNode}
                     onSearch={onSearchCollege}
                     filterOption={false}
                     allowClear
                     className="form-control w-100"
                     value={data?.college || ''}
                     onChange={(e) => setData({ ...data, college: e })}
                   >
                     <>
                       <Select.Option value="" key="" disabled>
                         Search for your School/College
                       </Select.Option>
                       {collegeDropdown &&
                         collegeDropdown?.data?.length !== 0 &&
                         collegeDropdown?.data?.map((item, idx) => (
                           <Select.Option value={item.id} key={idx}>
                             {item.name}
                           </Select.Option>
                         ))}
                     </>
                   </Select>
                 </div>
               </div>
             </div>

             <div className="form-group">
               <textarea
                 name="message"
                 value={data.message}
                 className="form-control w-100"
                 placeholder="Why do you want to become a student ambassador?"
                 onChange={(e) => setData({ ...data, message: e.target.value })}
                 required
                 style={{ resize: 'none' }}
               ></textarea>
             </div>

             <div className="contact-send-btn text-center">
               <Button
                 className="btn-secondary border-danger"
                 size="large"
                 htmlType="submit"
                 loading={status === 'request'}
               >
                 Submit
               </Button>
             </div>
           </form>
         </Col>
       </Row>
     </div>
   );
};

export default AmbassadorForm;
